const MAX_INVOICE_PDF_BYTES = 10 * 1024 * 1024

export function validateInvoicePdf(file: File): string | null {
  if (file.type && file.type !== 'application/pdf') return 'Only PDF files are accepted'
  if (file.size > MAX_INVOICE_PDF_BYTES) return 'PDF must be 10 MB or smaller'
  return null
}
